<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details">
        <h1>比《延禧攻略》还要火的上海抢房攻略，果断收藏！</h1>
        <p class="author">
          <span><a>蓝海购</a></span
          ><span>2018-08-31</span>
        </p>
        <!-- <div class="dynamics_img">
          <img
            style="max-width: 100%"
            src="~@/assets/images/BOSdynamics1.gif"
          />
        </div> -->
        <p>要问今年暑期档，哪部电视剧最火？《延禧攻略》绝对能拔得头筹！</p>
        <p>
          因采用了莫兰迪色系而显得舒服高级的画面色调；教科书般的服饰妆容；腹黑聪慧，脾气火爆的女主；善良温柔，实力团宠的皇后加上毒舌钢铁直男的皇上......
        </p>
        <p>
          从播出到完结，一共上了301次热搜，简直成了承包热搜榜的专业户！就连小编也忍不住加入追剧大军，不吃不喝不眠不休地一口气看上十几集。
        </p>

        <div class="dynamics_img">
          <!-- <img
            style="max-width: 100%"
            src="~@/assets/images/BOSdynamics2.jpg"
          /> -->

          <img style="max-width: 100%" v-lazy="aboutImg.picture1" />
        </div>
        <p>
          女主魏璎珞，就是一个女主光环加身的彻头彻尾的玛丽苏，但是她并不傻白甜，也不白莲花，而是机智勇敢、怼天怼地、快意恩仇，堪称是女主界的“泥石流”。
          魏璎珞能够从一个卑微的宫女，在“精英荟萃”的紫禁城中打怪升级，直至拿下皇后宝座，成为后宫的最强王者，很大程度上，是因为她深谙皇宫生存之道。
        </p>
        <div class="dynamics_img">
          <!-- <img
            style="max-width: 100%"
            src="~@/assets/images/BOSdynamics3.jpg"
          /> -->

          <img style="max-width: 100%" v-lazy="aboutImg.picture2" />

        </div>
        <p>
          其实呀，不仅是在皇宫，生活处处有套路，身边处处有“陷阱”，尤其是在买房的时候，总在犹豫选哪个盘升值快、有面子，最后挑房挑得眼花缭乱的你，很可能会因为一些不明所以的因素，买到不合意的房子！
        </p>
        <p>
          那么，在大上海，如何避开陷阱，拒绝犹豫，最终买到好房子呢？此时此刻，秉承一颗激动的心，我们竭诚为您推荐<span
            style="color: #b30112"
            >上海F1公馆</span
          >，详情如下：
        </p>
        <div class="dynamics_img">
          <!-- <img
            style="max-width: 100%"
            src="~@/assets/images/BOSdynamics4.jpg"
          /> -->

          <img style="max-width: 100%" v-lazy="aboutImg.picture3" />

        </div>
        <div class="lineStyle">
          <i></i>
          <p>上海好地段，自住有面子，投资不怕亏</p>
        </div>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSNewOne.jpg" /> -->

          <img v-lazy="aboutImg.picture4" />

        </div>
        <ul class="dynamics_ul">
          <li>
            F1公馆位于北虹桥、苏沪区域核心地段，拥有上海国际机电城、方泰镇等城市配套资源，拥享10分钟吃喝玩乐生活圈。
          </li>
          <li>
            周边3000余家企业环伺，辐射达5万余人流，坐享浑然天成的商业价值。
          </li>
          <li>
            更有方泰幼儿园，方泰小学等丰富教育资源，一站式优质教育配套，为3-12岁的孩子成长保驾护航。
          </li>
        </ul>
        <br />
        <p class="fontColor">
          没错，地段地段，还是地段，重要的事情说三遍，都不会嫌多有木有？！
        </p>
        <div class="lineStyle">
          <i></i>
          <p>高速口，地铁旁，享升值红利</p>
        </div>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSdynamics5.jpg" /> -->
          <img v-lazy="aboutImg.picture5" />

        </div>
        <ul class="dynamics_ul">
          <li>5分钟上高速，30分钟直抵虹桥枢纽。</li>
          <li>地铁11号线、公交3路赛车场站，轻松畅达全城。</li>
          <li>30分钟即可进入中环，咫尺抵达上海市中心。</li>
        </ul>
        <p class="fontColor fontColor1">没错，雅致风尚生活，从容切换！</p>
        <div class="lineStyle">
          <i></i>
          <p>精装修小户型，精粹品质生活方式</p>
        </div>
        <ul class="dynamics_ul">
          <li>景观公寓，南向落地飘窗，采光极佳。</li>
          <li>
            空间规划经济合理，人居环境精致优雅，营造温馨惬意的高端居住体验。
          </li>
        </ul>
        <p class="fontColor">
          没错，我们选择的不是户型，而是精神生活空间，更是一种魔都的生活方式！
        </p>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSdynamics6.jpg" /> -->
          <img v-lazy="aboutImg.picture6" />

        </div>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSdynamics7.jpg" /> -->
          <img v-lazy="aboutImg.picture7" />

        </div>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSdynamics8.jpg" /> -->
          <img v-lazy="aboutImg.picture8" />

        </div>
        <div class="dynamics_img">
          <!-- <img src="~@/assets/images/BOSdynamics9.jpg" /> -->
          <img v-lazy="aboutImg.picture9" />

        </div>
        <section
          class="houseTip"
          data-style-type="2"
          data-tools="新媒体排版"
          data-id="12817"
        >
          <section class="houseTipOne">
            <section class="houseTipTwo">
              <section class="houseTipThree">
                <p class="houseTipThreeContent">
                  <span style="font-size: 12px">
                    <strong>
                      <span style="font-family: 微软雅黑; color: rgb(255, 0, 0)"
                        >上海F1公馆，仅85万让你扎根大上海，</span
                      >
                    </strong>
                  </span>
                </p>
                <p class="houseTipThreeContentTwo">
                  <span style="font-size: 12px"
                    ><strong
                      ><span
                        style="
                          font-size: 12px;
                          font-family: 微软雅黑;
                          color: rgb(255, 0, 0);
                        "
                        >即将全城发售，</span
                      ></strong
                    ><strong
                      ><span
                        style="
                          font-size: 12px;
                          font-family: 微软雅黑;
                          color: rgb(255, 0, 0);
                        "
                        >机不可失，恭迎各位莅临品鉴！</span
                      ></strong
                    ></span
                  >
                </p>
              </section>
              <section class="houseTipFour"></section>
              <section class="houseTipFive"></section>
            </section>
          </section>
        </section>
        <p style="text-align: center; font-size: 20px">
          <strong>此刻，魔都不再高冷……</strong>
        </p>
      </div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    margin: 62px 260px 53px 260px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    .author {
      margin-top: 10px;
      display: flex;
      span:nth-of-type(1) {
        margin-right: 10px;
      }
      img {
        vertical-align: middle;
        margin: 0 10px;
      }
      a {
        color: #999999;
        font-size: 14px;
      }
      > span:nth-of-type(2) {
        color: #999999;
      }
    }
    h1 {
      font-size: 30px;
      max-width: 677px;
      margin: 0 auto;
      text-align: left;
    }
    p {
      font-size: 16px;
      line-height: 32px;
      margin: 0 auto;
      max-width: 677px;
      margin-bottom: 10px;
    }

    > p:nth-of-type(2) {
      margin-top: 40px;
    }

    > p:nth-of-type(5) {
      margin-top: 20px;
    }

    > p:nth-of-type(6) {
      margin-top: 40px;
    }

    div {
      text-align: center;
    }

    .dynamics_img {
      img {
        width: 677px;
        margin: 0 auto;
      }
    }
  }

  .houseTip {
    .houseTipOne {
      margin-top: 20px;
      .houseTipTwo {
        margin: 0 auto;
        width: 647px;
        .houseTipThree {
          border-color: rgb(131, 147, 209);
          border-radius: 5px;
          border-style: solid;
          border-width: 2px;
          padding: 10px 10px 15px;
          .houseTipThreeContent {
            font-size: 14px;
            color: rgb(121, 121, 121);
            text-align: center;
          }
          .houseTipThreeContentTwo {
            font-size: 14px;
            color: rgb(121, 121, 121);
            text-align: center;
          }
        }
        .houseTipFour {
          border-bottom-color: rgb(131, 147, 209);
          border-left-color: transparent !important;
          border-left-style: solid !important;
          border-left-width: 32.25px !important;
          border-right-color: transparent !important;
          border-right-style: solid !important;
          border-right-width: 32.25px !important;
          border-top-color: #33ebe4;
          border-top-style: solid;
          border-top-width: 27.6406px;
          color: inherit;
          height: 10px;
          margin-left: auto;
          margin-right: auto;
          width: 0px;
        }

        .houseTipFive {
          border-bottom-color: rgb(254, 254, 254);
          border-left-color: transparent !important;
          border-left-style: solid !important;
          border-left-width: 32.25px !important;
          border-right-color: transparent !important;
          border-right-style: solid !important;
          border-right-width: 32.25px !important;
          border-top-color: rgb(254, 254, 254);
          border-top-style: solid;
          border-top-width: 27.6406px;
          color: inherit;
          height: 10px;
          margin-left: auto;
          margin-right: auto;
          margin-top: -12px;
          width: 0px;
        }
      }
    }
  }
}

.lineStyle {
  i {
    width: 30px;
    height: 5px;
    display: inline-block;
    background: #d0a973;
  }
  p {
    border-bottom: 5px solid #b30112;
    width: 300px;
    margin: 0 auto;
    margin-bottom: 30px !important;
    font-weight: 600;
  }
}

.dynamics_ul {
  margin: 0 auto;
  max-width: 677px;
  font-weight: 600;
  li {
    font-size: 16px;
    list-style: circle;
    line-height: 45px;
  }
}

.fontColor {
  color: #b30112;
}

.fontColor1 {
  text-align: center;
  margin-top: 20px !important;
  margin-bottom: 40px;
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .dynamic_details {
      margin: 62px 8% 53px 11.5%;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import aboutImgOne from "@/assets/images/BOSdynamics2.jpg";
import aboutImgTwo from "@/assets/images/BOSdynamics3.jpg";
import aboutImgThree from "@/assets/images/BOSdynamics4.jpg";
import aboutImgFour from "@/assets/images/BOSNewOne.jpg";
import aboutImgFive from "@/assets/images/BOSdynamics5.jpg";
import aboutImgSix from "@/assets/images/BOSdynamics6.jpg";
import aboutImgSeven from "@/assets/images/BOSdynamics7.jpg";
import aboutImgEight from "@/assets/images/BOSdynamics8.jpg";
import aboutImgNine from "@/assets/images/BOSdynamics9.jpg";
import aboutImgTen from "@/assets/images/BOSdynamics7.jpg";


export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      aboutImg:{
        picture1:aboutImgOne,
        picture2:aboutImgTwo,
        picture3:aboutImgThree,
        picture4:aboutImgFour,
        picture5:aboutImgFive,
        picture6:aboutImgSix,
        picture7:aboutImgSeven,
        picture8:aboutImgEight,
        picture9:aboutImgNine,
        picture10:aboutImgTen,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>